import { getApiErrorMessage } from "../utils/apierror";
import { BaseService } from "./BaseService";

export class SelectionsetService extends BaseService {
  async getSelectionsets(profileId) {
    const result = await super.invokeGet(
      this.APICONFIG.APIBASEURL + this.APICONFIG.SELECTIONSET + "?profileID=" + profileId
    );
    if (!Array.isArray(result)) {
      throw new Error(getApiErrorMessage(result, "Unable to download Selection Sets. Please try again."));
    }
    return result.map((item) => {
      item.isFolder = item.isFolder ? "TRUE" : "FALSE";
      return item;
    });
  }
}
